import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Zoom from '@material-ui/core/Zoom'
import {Checkbox, FormControlLabel} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning';

import Header from './results/header'
import ButtonGroup from './results/buttongroup'
import Subheader from './results/subheader'



import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        
    },
    header: {
        textAlign: 'center',
        marginBottom: '0px'
    },
    card: {
        padding: '0 1vw 1em 1vw',
        marginTop: '5em',
        textAlign: 'center'
    },
    center: {
        textAlign: 'center',
        justifyContent: 'center'
    },
    errorIcon: {
        color: 'red',
        fontSize: '150px',
        marginTop: '10px',
        marginBottom: '-20px'
    }
});

class Error extends Component {
    constructor(props){
        super(props)
        this.state = {
            showTsCs:false,
            acceptsTCs:false,

            segmentLabels:[],
            segmentBreakpoints:[]
        }
        console.log(props)
    }

    render(){
        const {classes} = this.props
        let resultItems = []
        let component, x;
        x=0;
        while(x<this.props.error.length){
            //resultItem = ;
            component=this.props.error[x];
            switch(component.ComponentClass) {
                case "TEXTAREA":
                    if(component.ComponentType == "HEADER"){
                        resultItems.push(<Header gradeLabel={component.ComponentContent.GradeLabel} content={component.ComponentContent.Title} type={""}/>)
                    }
                    if(component.ComponentType == "SUBHEADER"){
                        resultItems.push(<Subheader content={component.ComponentContent.Content}/>)
                    }
                    break;
                case "CONTROLS":
                    if (component.ComponentType == "BUTTON GROUP"){
                        resultItems.push(<ButtonGroup buttons={component.ComponentContent.Buttons} />)
                    }
                    break;
            }
            //console.log(resultItems)
            //resultItems.push(resultItem);
            x++;
        }

        return(
            <Card className={classes.card} raised="true">
                <WarningIcon className={classes.errorIcon} />
                <CardContent>
                    {resultItems}
                </CardContent>
            </Card>
        )
    }
}

export default withStyles(styles)(Error);